import styled from "styled-components";

export const FooterWrapper = styled.div`
  background-color: rgb(51, 51, 51, 1);
  position: relative;
  overflow: hidden;
  .footerLine_bg_Image {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    @media (max-width: 1199px) {
      object-fit: contain;
    }
  }
  .ftr_upper_wrap {
    padding: 90px 0px 65px;
    @media (max-width: 1199px) {
      padding: 50px 0px;
    }
    @media (max-width: 899px) {
      padding: 40px 0px;
    }
    .ftr_upper {
      max-width: 1335px;
      margin: 0px auto;
      .footer_row {
        margin: -15px;
        .footer_col {
          width: 25%;
          padding: 15px;
          @media (max-width: 899px) {
            width: 100%;
          }
          &.footerLeftBox {
            width: 48%;
            @media (max-width: 1199px) {
              width: 47%;
            }
            @media (max-width: 899px) {
              width: 100%;
            }
          }
          &.ftr_Contact_col {
            width: calc(100% - (48% + 25%));
            @media (max-width: 899px) {
              width: 100%;
            }
          }
          .footer_logo {
            filter: invert(1) hue-rotate(-179deg);
            @media (max-width: 1199px) {
              max-width: 170px;
            }
            @media (max-width: 899px) {
              max-width: 150px;
            }
            @media (max-width: 599px) {
              max-width: 120px;
            }
          }

          .footer_nav_links {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: -5px -5px -20px;
            li {
              width: 50%;
              padding: 5px 5px 20px;
              @media (max-width: 899px) {
                width: 100%;
                padding: 5px 5px 12px;
              }
              a {
                line-height: 1;
                color: rgb(255, 255, 255);
                transition: all 0.4s ease-in-out;
              }
              &.active {
                a {
                  color: rgb(255, 24, 24);
                }
              }
              &:hover {
                a {
                  color: rgb(255, 24, 24);
                }
              }
            }
          }
          .social_link_div {
            margin-top: 30px;
            @media (max-width: 899px) {
              margin-top: 20px;
            }
            .social_Media_Icons {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              margin-top: 10px;
              li {
                width: auto;
                &:not(:last-child) {
                  margin-right: 25px;
                }
                a {
                  display: flex;
                  width: 30px;
                  height: 30px;
                  color: rgba(256, 256, 256, 1);
                  transition: 0.4s ease-in-out;
                }
                &:hover {
                  a {
                    color: rgb(255, 24, 24);
                  }
                }
              }
            }
          }
          .ftr_cmn_heading {
            font-weight: 700;
            font-size: 20px;
            line-height: 1.2;
            color: rgb(255, 255, 255);
            margin-bottom: 25px;
            @media (max-width: 899px) {
              font-size: 16px;
              margin-bottom: 20px;
            }
          }
          .ftr_contact_list {
            li {
              font-weight: 600;
              color: rgb(255, 255, 255);
              align-items: flex-start;
              transition: all 0.4s ease-in-out;

              &:not(:last-child) {
                margin-bottom: 20px;
              }
              &:hover {
                a {
                  color: rgb(255, 24, 24);
                }
              }
              i {
                line-height: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                margin-right: 8px;
                color: rgb(255, 24, 24);
                transition: all 0.4s ease-in-out;
                width: 25px;
                height: 25px;
              }
              span {
                max-width: calc(100% - 33px);
                width: 100%;
                overflow-wrap: break-word;
              }
              a {
                all: inherit;
                width: 100%;
                cursor: pointer;
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
  .description_text {
    color: rgb(255, 255, 255);
    margin-top: 20px;
  }
  .ftr_btm {
    padding: 20px 0px;
    border-top: 1px solid rgb(82, 82, 82);
    text-align: center;
    p {
      margin-top: 0;
      a {
        all: inherit;
        cursor: pointer;
        display: inline-block;
        margin-left: 5px;
        transition: 0.4s ease-in-out;
        &:hover {
          color: rgb(255, 24, 24);
        }
      }
    }
  }
`;
